const WHATSAPP_CONVERSATION_TYPES = new Set(["chat", "chat_bot"]);

const toCount = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

export const whatsappConversationTotals = (rows) => {
  const matched = Array.isArray(rows)
    ? rows.filter((row) => WHATSAPP_CONVERSATION_TYPES.has(row?.provider_type))
    : [];
  const current = matched.reduce((sum, row) => sum + toCount(row?.current), 0);
  const previous = matched.reduce(
    (sum, row) => sum + toCount(row?.previous),
    0,
  );
  const changePercentage =
    previous > 0 ? ((current - previous) / previous) * 100 : null;

  return { current, previous, changePercentage };
};
